import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TokenGuard } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons"; // Icon for confirmation
import { StandardURL } from "../App";

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${StandardURL}/iNyumba/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Logout successful!");
      localStorage.clear(); // Clear all local storage data
      navigate("/"); // Redirect to the login page
    } catch (error) {
      console.error(error);
      toast.error("Logout failed. Please try again."); // More user-friendly error
    }
  };

  const handleNo = () => {
    navigate("/landlord/home"); // Navigate back to the home page
  };

  return (
    <TokenGuard>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center space-y-6">
          <FontAwesomeIcon icon={faQuestionCircle} className="text-6xl text-blue-500 mb-4" />
          <h2 className="text-3xl font-extrabold text-gray-900">
            Confirm Logout
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Are you sure you want to log out?
          </p>
          <div className="flex justify-center space-x-4 mt-6">
            <button
              onClick={handleLogout}
              className="px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-300 shadow-md"
            >
              Yes, Logout
            </button>
            <button
              onClick={handleNo}
              className="px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-300 shadow-md"
            >
              No, Stay Logged In
            </button>
          </div>
        </div>
      </div>
    </TokenGuard>
  );
};

export default Logout;